import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LocalizationContext } from '../localization/LocalizationContext';
import '../css/index.css';
import '../css/bar.css';
import En from '../img/en.svg';
import Ge from '../img/ge.svg';
import Uk from '../img/uk.svg';
import Ru from '../img/ru.svg';
import Ar from '../img/ar.svg';
import Tr from '../img/tr.svg';
import deliveryRiderIcon from "../img/fastdelivery-logo.png";
import fastDeliveryTextLogo from "../img/fastdelivery-logori.png";
import { getOrderMode, ORDER_MODE_CHANGE_EVENT, ORDER_MODES, setOrderMode } from '../utils/orderMode';
export const languages = [
  { code: 'en', label: 'En' },
  { code: 'ge', label: 'ქა' },
  // { code: 'it', label: 'It' },
  // { code: 'ar', label: 'Ar' },
  // { code: 'tr', label: 'Tr' },
  { code: 'ru', label: 'Ру' },
];


function Bar() {
  const navigate = useNavigate();
  const { switchLanguage, locale, translations } = useContext(LocalizationContext);
  const [selectedLanguage, setSelectedLanguage] = useState(locale);
  const [orderMode, setSelectedOrderMode] = useState(getOrderMode());

  const flags = {
    en: En,
    ge: Ge,
    it: Uk,
    ar: Ar,
    tr: Tr,
    ru: Ru,
  };
  const [showLabel, setShowLabel] = useState(false);

  useEffect(() => {
    setSelectedLanguage(locale);
  }, [locale]);

  useEffect(() => {
    const handleExternalOrderModeChange = (event) => {
      setSelectedOrderMode(event.detail || getOrderMode());
    };

    window.addEventListener(ORDER_MODE_CHANGE_EVENT, handleExternalOrderModeChange);
    window.addEventListener('storage', handleExternalOrderModeChange);

    return () => {
      window.removeEventListener(ORDER_MODE_CHANGE_EVENT, handleExternalOrderModeChange);
      window.removeEventListener('storage', handleExternalOrderModeChange);
    };
  }, []);

  const handleOrderModeChange = (mode) => {
    setSelectedOrderMode(setOrderMode(mode));
    navigate(mode === ORDER_MODES.DELIVERY ? '/delivery' : '/dinein');
  };

  const changeLanguage = (lng) => {
    switchLanguage(lng);
    setSelectedLanguage(lng);
  };

  return (
    <div className="Bar_container">
      <div className="Bar">
        <div className="Icons">
          <div className="logos-container">
            <div className="logo-wrapper active">
              <div className="fastdelivery-navbar-logo" aria-label="FastDelivery.ge">
                <img src={deliveryRiderIcon} className="fastdelivery-navbar-icon" alt=""/>
                <img src={fastDeliveryTextLogo} className="fastdelivery-navbar-wordmark" alt="FastDelivery.ge"/>
              </div>
            </div>
            <div className="order-mode-toggle" role="group" aria-label="Order mode">
              <button
                type="button"
                className={`order-mode-option ${orderMode === ORDER_MODES.DINE_IN ? 'active' : ''}`}
                onClick={() => handleOrderModeChange(ORDER_MODES.DINE_IN)}
              >
                {translations?.deliveryPage?.AtTheTable || 'Dine-in'}
              </button>
              <button
                type="button"
                className={`order-mode-option ${orderMode === ORDER_MODES.DELIVERY ? 'active' : ''}`}
                onClick={() => handleOrderModeChange(ORDER_MODES.DELIVERY)}
              >
                {translations?.deliveryPage?.delivery || 'Delivery'}
              </button>
            </div>
          </div>
          <div className="swicher"></div>

          <div className="lang">
            <img className="flag" src={flags[selectedLanguage]} alt="Flag"/>
            <div className="language-wrapper">
              <select
                  className="language-dropdown"
                  value={selectedLanguage}
                  onChange={(e) => changeLanguage(e.target.value)}
                  onFocus={() => setShowLabel(true)}
                  onBlur={() => setShowLabel(false)}
              >
                {languages.map((lang) => (
                    <option key={lang.code} value={lang.code}>
                      {lang.label}
                    </option>
                ))}
              </select>
              {showLabel && (
                  <div className="lang-label">
                    {
                      languages.find((lang) => lang.code === selectedLanguage)?.label
                    }
                  </div>
              )}
            </div>
          </div>

          {/*<div className="IconsR">*/}
          {/*  <div className="Icon">*/}
          {/*    <div*/}
          {/*        className="Burger"*/}
          {/*        onClick={({target}) => target.classList.toggle('active')}*/}
          {/*    >*/}
          {/*      <div className="burgerICO">*/}
          {/*        <svg*/}
          {/*            id="line"*/}
          {/*            className="ham hamRotate ham1 null"*/}
          {/*            viewBox="0 0 100 100"*/}
          {/*            width="57"*/}
          {/*        >*/}
          {/*          <path*/}
          {/*              className="line top path"*/}
          {/*              d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"*/}
          {/*          ></path>*/}
          {/*          <path className="line middle path" d="m 30,50 h 40"></path>*/}
          {/*          <path*/}
          {/*              className="line bottom path"*/}
          {/*              d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"*/}
          {/*          ></path>*/}
          {/*        </svg>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  );
}

export default Bar;
